<template>
  <div id="story">
    <div class="storyWrap" v-show="this.mode === 'story'">
      <component v-if="currentData.type === 'opening' || currentData.type === 'opening_finish'"
                 :is="titleCmp"
                 :val="storyData.title">
      </component>
      <Panel class="imgArea" v-if="currentData.type !== 'profile' && currentData.type !== 'badend_shijo' && currentData.type !== 'cover' && currentData.type !== 'game' && currentData.type !== 'clear'"
                :imgsrc="currentData.pnlImg"
                @btnTap="onSelectAns">
      </Panel>
      <OpeningBtns class="btnsArea" v-if="currentData.type === 'opening_finish'" @selectOpening="onSelectOpening"></OpeningBtns>
      <TextArea v-if="currentData.type !== 'opening_finish' && currentData.type !== 'profile' && currentData.type !== 'badend_shijo' && currentData.type !== 'cover' && currentData.type !== 'game' && this.judge === null"
                :scene="currentScene"
                :title="currentData.frmTit"
                :txtsrc="currentData.frmSrc"
                :arrow="currentData.frmArw"
                :type="currentData.type"
                @updateBtns="updateBtns" 
                @frameTap="onFrameTap">
      </TextArea>
      <component v-if="currentData.type === 'question' || currentData.type === 'correct' || currentData.type === 'badend' || currentData.type === 'clear'"
                 :is="ansAreaCmp" ref="btns"
                 @selectAns="onSelectAns" 
                 @selectBadEnd="onSelectBadEnd" 
                 @selectCorrect="onSelectCorrect"
                 @inputAns="onInputAns"
                 @judgeAns="onJudgeAns"
                 @backtoTop="backtoTop"
                 @retryStory="retryStory">
      </component>
      <Profile v-if="currentData.type === 'profile'" @selectOpening="onSelectOpening"></Profile>
      <ShijoBadend v-if="currentData.type === 'badend_shijo'" @panelTap="onFrameTap"></ShijoBadend>
      <FujiwaraCover v-if="currentData.type === 'cover'" :qVal="currentData.sceneNm" @panelTap="onFrameTap"></FujiwaraCover>
    </div>
    
    <div class="gameWrap" v-if="this.mode === 'game'">
      <component :is="gameCmp" ref="game"
                 @gameResult="onGetGameResult">
      </component>
    </div>

    <!--- 結果全面表示 -->
    <ResultCorrect v-if="this.judge === 'correct'" @click.native="onClickResult"></ResultCorrect>
    <ResultBadEnd v-if="this.judge === 'badend'" @click.native="onClickResult"></ResultBadEnd>
    <ResultClear v-if="this.judge === 'clear'" :chara="storyData.name" @allClear="onSelectNextAct"></ResultClear>
    <Ending v-if="this.endingFlag === true"></Ending>
  </div>
</template>

<script>
  import _$ from 'jquery'
  // import _ from 'lodash'

  import Title from '@/components/Title.vue'
  import Panel from '@/components/Panel.vue'
  import OpeningBtns from '@/components/OpeningBtns.vue'
  import TextArea from '@/components/TextArea.vue'
  import AnsBtnSet from '@/components/AnsBtnSet.vue'
  import BadEndSet from '@/components/BadEndSet.vue'
  import CorrectSet from '@/components/CorrectSet.vue'
  import Profile from '@/components/Profile.vue'
  import ResultBadEnd from '@/components/ResultBadend.vue'
  import ResultCorrect from '@/components/ResultCorrect.vue'
  import ResultClear from '@/components/ResultClear.vue'
  import InputAns from '@/components/InputAns.vue'
  import Ending from '@/components/Ending.vue'

  // キャラ固有のコンポーネント
  import ShiroganeQ4 from '@/components/ShiroganeQ4.vue'
  import HayasakaQ4 from '@/components/HayasakaQ4.vue'
  import ShijoBadend from '@/components/ShijoBadend.vue'
  import FujiwaraTitle from '@/components/FujiwaraTitle.vue'
  import FujiwaraCover from '@/components/FujiwaraCover.vue'

  // ミニゲームのコンポーネント
  import HayasakaGame from '@/components/Game_01.vue'
  import KaguyaGame from '@/components/Game_03.vue'
  import TsubameGame from '@/components/Game_02.vue'
  import FujiwaraGame from '@/components/Game_04.vue'

  export default {
    name: 'Story',
    components: {
      Title,
      Panel,
      OpeningBtns,
      TextArea,
      AnsBtnSet,
      BadEndSet,
      CorrectSet,
      Profile,
      ResultBadEnd,
      ResultCorrect,
      ResultClear,
      InputAns,
      Ending,
      ShiroganeQ4,
      HayasakaQ4,
      ShijoBadend,
      FujiwaraTitle,
      FujiwaraCover,
      HayasakaGame,
      KaguyaGame,
      TsubameGame,
      FujiwaraGame
    },
    props: {
      // storyData: Object
    },
    data(){
      return {
        publicPath: process.env.BASE_URL,
        // --------------------------------
        storyData: null,
        currentScene: null,
        currentData: [],
        state: null,
        imgSrc: null,
        mode: 'story',
        totalPageNum: null,

        titleCmp: null,
        ansAreaCmp: null,
        gameCmp: null,

        ansBtns: null,

        judge: null,
        judgeFlag: true,
        timer: null,

        endingFlag: false
      }
    },
    mounted() {
      this.updateStoryData()
    },
    destroyed () {
      clearTimeout(this.timer)
    },
    watch: {
      storyData(newValue) {
        if(newValue){
          this.currentData = newValue.pages[this.currentScene]
          this.totalPageNum = Object.keys(this.storyData.pages).length

          switch(newValue.name){
            case 'hayasaka':
              this.gameCmp = HayasakaGame
              break
            case 'kaguya':
              this.gameCmp = KaguyaGame
              break
            case 'tsubame':
              this.gameCmp = TsubameGame
              break
            case 'fujiwara':
              this.gameCmp = FujiwaraGame
          }
        }
      },
      currentScene(newValue) {
        this.currentData = this.storyData.pages[newValue]
        this.judgeFlag = true
        
        // 画像エリア＆ボタンエリアの高さ変更
        switch(true){
          case this.storyData.name === 'shirogane' && this.currentScene === 70:
            _$('#story .imgArea').addClass('type1')
            break
          case this.storyData.name === 'hayasaka' && this.currentScene === 36:
            _$('#story .imgArea').addClass('type2')
            break
          default:
            if(_$('#story .imgArea').hasClass('type1')){
              _$('#story .imgArea').removeClass('type1')
            }
            if(_$('#story .imgArea').hasClass('type2')){
              _$('#story .imgArea').removeClass('type2')
            }
        }
      },
      currentData(newValue) {
        this.state = newValue.type
        this.imgSrc = newValue.pnlImg
        this.ansBtns = newValue.ans
        this.ansAreaCmp = null

        this.mode = (this.state === 'game') ? 'game' : 'story'
      }
    },
    computed: {

    },
    methods: {
      updateStoryData(){
        this.storyData = this.$parent.currentStoryData
        this.currentScene = this.getStartScene()

        if(this.storyData.name === 'fujiwara'){
          this.titleCmp = FujiwaraTitle
        } else {
          this.titleCmp = Title
        }
      },
      getStartScene(){
        // スタートするシーン番号を算出
        let storyPosObj = this.$parent.storageData.storyPos,
            sceneNum = storyPosObj[this.storyData.name],
            startScene = null

        if(sceneNum){
          for(let i = this.storyData.chapter.length - 1; i >= 0; i--){
            if(sceneNum > this.storyData.chapter[i]){
              if(this.storyData.name === 'fujiwara' && i <= 3){
                startScene = this.storyData.chapter[i + 1]
              } else {
                startScene = this.storyData.chapter[i]
              }
              break;
            }
          }
        } else {
          startScene = 0
        }
        return startScene
      },
      updateBtns(){
        switch(this.state){
          case 'question':
            switch(true){
              case this.storyData.name === 'ishigami' && this.currentScene === 40:
              case this.storyData.name === 'hayasaka' && (this.currentScene === 29 || this.currentScene === 30 || this.currentScene === 31):
              case this.storyData.name === 'tsubame' && (this.currentScene === 25 || this.currentScene === 26 || this.currentScene === 27):
                // テキスト入力問題
                this.ansAreaCmp = InputAns
                break
              case this.storyData.name === 'shirogane' && this.currentScene === 70:
                // 白銀 第4問
                this.ansAreaCmp = ShiroganeQ4
                break
              case this.storyData.name === 'hayasaka' && this.currentScene === 36:
                // 早坂 第4問
                this.ansAreaCmp = HayasakaQ4
                break
              case this.ansAreaCmp !== AnsBtnSet:
                // イレギュラーから通常のボタンセットに変更
                this.ansAreaCmp = AnsBtnSet
                break
              default:
                // 通常のボタンセットだった場合は内容をアップデート
                this.$refs.btns.updateAnsData()
            }
            break;
          case 'badend':
            this.ansAreaCmp = BadEndSet
            break
          case 'correct':
            this.ansAreaCmp = CorrectSet
        }
        this.exceptionalAction()
      },
      onFrameTap: function(){
        // テキストエリアをタップ -------------------------------
        switch(true){
          case this.currentScene + 1 === this.totalPageNum:
            // ending
            this.judge = 'clear'
            this.$parent.saveClearState(this.storyData.name)

            if(this.storyData.name === 'fujiwara'){
              this.endingFlag = true
            }
            break
          case this.storyData.name === 'shijo' && (this.currentScene >= 7 && this.currentScene <= 10):
            this.currentScene = this.currentData.nextScene
            break
          default:
            this.currentScene++
        }
      },
      onSelectOpening: function(val){
        // オープニング プロフィール or 問題
        if(val === 'profile'){
          this.currentScene++
        } else {
          this.currentScene += 2
        }
      },
      onSelectAns: function(val){
        // --- ansAreaCmp → 答え選択結果受信
        let nextSceneNum = null
        if(this.storyData.name === 'fujiwara' && this.currentScene === 46 && val === 9){
          nextSceneNum = this.currentData.nextScene
        } else {
          nextSceneNum = this.currentData.ans[val].nextScene
        }
        // console.log("*** select ans :", val, " / nextScene:", nextSceneNum, this.storyData.name)
        switch(true){
          case this.currentData.correct === val && this.judgeFlag:
          case this.storyData.name === 'shijo':
            // ***** 正解 *****
            this.judge = 'correct'

            // --- 例外パターン（解答ボタン押下直後）---------------

            // 'CORRECT画面を出さずに次の問題へ遷移する場合
            switch(true){
              case this.storyData.name === 'iino' && (this.currentScene >= 44 && this.currentScene <= 48):
              case this.storyData.name === 'ishigami' && (this.currentScene >= 31 && this.currentScene <= 34):
                this.judge = null
            }
            break;
          default:
            // ***** 不正解 *****
            this.judge = 'badend'
            this.$parent.saveStartPos(this.storyData.name, this.currentScene)

            // --- 例外パターン（解答ボタン押下直後）---------------
            switch(true){
              case this.storyData.name === 'ishigami' && this.currentScene === 26:
                nextSceneNum = 28
                break
              case this.storyData.name === 'fujiwara' && this.currentScene === 55 && val === 3:
                nextSceneNum = 57
            }
        }
        clearTimeout(this.timer)
        this.currentScene = nextSceneNum;
      },
      onInputAns: function(val){
        // テキスト入力問題 -----------------------------------
        let result = this.currentData.correct.includes(val)

        // console.log(val, result)

        if(result){
          // ***** 正解 *****
          switch(true){
            case this.storyData.name === 'hayasaka' && (this.currentScene === 29 || this.currentScene == 30):
            case this.storyData.name === 'tsubame' && (this.currentScene === 25 || this.currentScene == 26):
              this.judge = null
              break
            default:
              this.judge = 'correct'
          }
          this.currentScene = this.currentData.success
        } else {
          // ***** 不正解 *****
          this.judge = 'badend'
          this.currentScene = this.currentData.failure
          this.$parent.saveStartPos(this.storyData.name, this.currentScene)
        }
      },
      onJudgeAns: function(val){
        // 複数選択問題 ------------------------------------
        switch(this.storyData.name){
          case 'shirogane':
            // +++++ 白銀 Q4 +++++
            // console.log('onJudgeAns_shiroganeQ4', val)
            switch(val){
              case 'correct':
                this.currentScene = 77
                this.judge = 'correct'
                break
              case 'badend1':
                this.currentScene = 74
                this.judge = 'badend'
                break
              case 'badend2':
                this.currentScene = 71
                this.judge = 'badend'
            }
            break
          case 'hayasaka':
            // +++++ 早坂 Q4 +++++
            // console.log('onJudgeAns_hayasakaQ4', val)
            this.judge = val
            switch(val){
              case 'correct':
                this.currentScene = this.currentData.success
                break
              case 'badend':
                this.currentScene = this.currentData.failure
            }
        }
        if(this.judge === 'badend'){
          this.$parent.saveStartPos(this.storyData.name, this.currentScene)
        }
      },
      onSelectBadEnd: function(val){
        // BAD END - 攻略本選択結果受信
        // console.log("*** select badend :", val)
        if(val === 'yes'){
          // はい → 攻略本（試し読み）
          window.location.href = this.currentData.trial
        } else {
          // いいえ → トップへ
          this.backtoTop()
        }
      },
      onSelectCorrect: function(){
        // CORRECT - 次へボタン押下
        // console.log("*** select correct ***")
        this.currentScene++
      },
      onGetGameResult: function(val){
        // ゲーム結果受信 ---------------------------
        // console.log("*** game result *** ", val)
        if(val){
          // 成功
          this.currentScene = this.currentData.success
          this.judge = 'correct'
        } else {
          // 失敗
          this.currentScene = this.currentData.failure
          this.judge = 'badend'
          this.$parent.saveStartPos(this.storyData.name, this.currentScene)
        }
      },
      onClickResult: function(){
        this.judge = null
      },
      backtoTop: function(){
        this.$emit('changeState', 'top')
      },
      retryStory: function(){
        this.currentScene = this.getStartScene()
      },
      exceptionalAction: function(){
        // ------ 例外パターン（シーン切り替え直後）-------------
        switch(this.storyData.name){
          case 'ishigami':
            switch(this.currentScene){
              case 22:
              case 23:
              case 24:
              case 25:
                // +++++ 石上 Q3 +++++
                this.timer = setTimeout(function(){
                  this.currentScene++
                  clearTimeout(this.timer)
                }.bind(this), 3000);
                break;
              case 26:
                // +++++ 石上 Q3 - 5 +++++
                this.timer = setTimeout(function(){
                  clearTimeout(this.timer)
                  this.judgeFlag = false
                }.bind(this), 4000);
            }
            break;
          case 'kaguya':
            switch(this.currentScene){
              case 30:
              case 31:
              case 32:
                // +++++ かぐや Q2 +++++
                this.timer = setTimeout(function(){
                  this.currentScene++
                  clearTimeout(this.timer)
                }.bind(this), 3000);
                break;
              case 33:
                // +++++ かぐや Q2 +++++
                this.timer = setTimeout(function(){
                  this.currentScene++
                  clearTimeout(this.timer)
                  this.judge = 'badend'
                  this.$parent.saveStartPos(this.storyData.name, this.currentScene)
                }.bind(this), 4000);
            }
            break
          case 'shijo':
            // +++++++ 四条 ++++++++
            if(this.currentScene === 4){
              this.timer = setTimeout(function(){
                this.currentScene++
                clearTimeout(this.timer)
                this.judge = 'badend'
                this.$parent.saveStartPos(this.storyData.name, this.currentScene)
              }.bind(this), 30 * 1000);
            }
            break
          case 'fujiwara':
            // +++++++ 藤原 ++++++++
            switch(this.currentScene){
              case 55:
                this.timer = setTimeout(function(){
                  this.currentScene = 57
                  clearTimeout(this.timer)
                  this.judge = 'badend'
                  this.$parent.saveStartPos(this.storyData.name, this.currentScene)
                }.bind(this), 1000);
                break
              case 60:
                this.timer = setTimeout(function(){
                  this.currentScene = 64
                  clearTimeout(this.timer)
                  this.judge = 'badend'
                  this.$parent.saveStartPos(this.storyData.name, this.currentScene)
                }.bind(this), 1000);
            }

          // --------------------------------------
        }
      },
      onSelectNextAct: function(val){
        // --- 全クリア後 次の遷移先
        // console.log('**** all clear:', val);

        this.$parent.onChangeState(val)
      }
    }
  }
</script>


<style lang="scss" scoped>
  #story {
    width: 100%;
    height: 100%;
    position: relative;

    .storyWrap,
    .gameWrap {
      width: 100%;
      height: 100%;
    }
    .imgArea {
      height: calc(100% - 76.8vw);

      &.type1 {
        height: calc(100% - 90.9vw);
      }

      &.type2 {
        height: calc(100% - 105.3vw);
      }
    }
    .btnsArea {
      height: 76.8vw;
    }
  }
</style>
